import React, { useState, useEffect, memo } from 'react';
import { Box, Typography } from '@mui/material';
import Background from '../layout/Background';

const formatNumber = (num) => {
    return num.toString().padStart(2, '0');
};

const TimeUnit = memo(({ value, label }) => (
    <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    }}>
        <Box sx={{
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.35)',
            backdropFilter: 'blur(12px)',
            borderRadius: { xs: '12px', sm: '16px', md: '20px' },
            padding: { xs: '12px 14px', sm: '14px 18px', md: '16px 22px' },
            // border: '1px solid rgba(255, 255, 255, 0.15)',
            minWidth: { xs: '50px', sm: '65px', md: '80px' },
        }}>
            <Background backgroundColor="transparent" countStars={3} />

            <Typography
                sx={{
                    position: 'relative',
                    zIndex: 1,
                    fontSize: { xs: '1.8rem', sm: '2.2rem', md: '2.4rem', lg: '2.6rem' },
                    fontWeight: 700,
                    color: '#FFFFFF',
                    lineHeight: 1,
                    fontFamily: 'monospace',
                    textAlign: 'center',
                }}
            >
                {formatNumber(value)}
            </Typography>
        </Box>
        <Typography
            sx={{
                fontSize: { xs: '0.6rem', sm: '0.7rem', md: '0.75rem', lg: '0.8rem' },
                fontWeight: 500,
                color: 'rgba(255, 255, 255, 0.8)',
                textTransform: 'uppercase',
                letterSpacing: { xs: '0.1em', sm: '0.2em', md: '0.25em' },
                mt: { xs: 0.5, sm: 0.6 },
                textAlign: 'center',
                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            }}
        >
            {label}
        </Typography>
    </Box>
));

TimeUnit.displayName = 'TimeUnit';

const CountdownTimer = ({ targetDate }) => {
    const [timeLeft, setTimeLeft] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    });

    useEffect(() => {
        const calculateTimeLeft = () => {
            const now = new Date().getTime();
            const target = new Date(targetDate).getTime();
            const difference = target - now;

            if (difference > 0) {
                setTimeLeft({
                    days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                    hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
                    minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
                    seconds: Math.floor((difference % (1000 * 60)) / 1000)
                });
            } else {
                setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
            }
        };

        calculateTimeLeft();
        const interval = setInterval(calculateTimeLeft, 1000);

        return () => clearInterval(interval);
    }, [targetDate]);

    return (
        <Box sx={{
            display: 'flex',
            gap: { xs: '8px', sm: '16px', md: '20px' },
            alignItems: 'center',
            flexWrap: { xs: 'nowrap', sm: 'wrap' },
        }}>

            <TimeUnit value={timeLeft.days} label="DÍAS" />
            <TimeUnit value={timeLeft.hours} label="HORAS" />
            <TimeUnit value={timeLeft.minutes} label="MINUTOS" />
            <TimeUnit value={timeLeft.seconds} label="SEGUNDOS" />
        </Box>
    );
};

export default CountdownTimer;

